import { DocumentCurrencyDollarIcon } from "@heroicons/react/24/solid";
import useOrderPage from "@/viewModels/order/useOrderPage";
import LabelInput from "@/components/ui/form/LabelInput";
import OrderDetails from "@/components/features/orders/OrderDetails";
import ErrorMessage from "@/components/ui/form/ErrorMessage";
import SEOMeta from "@/components/ui/meta/SEOMeta";
import OfficialLINE from "@/components/ui/OfficialLINE";
import SpinnerLoading from "@/components/ui/loading/SpinnerLoading";

const OrderPage = () => {
  const { order, isSubmitting, orderResultError, errors, register, watch, handleFormSubmit } =
    useOrderPage();

  return (
    <main className="brand-main">
      <div className="brand-container max-w-screen-md py-4 lg:py-8">
        <section className="brand-card brand-order-details-card items-center space-y-2 text-center">
          <DocumentCurrencyDollarIcon className="box-content size-12 p-2" />
          <h1 className="text-2xl font-bold">查詢訂單</h1>
          <p className="brand-text-sm text-secondary">
            請填寫您的「訂單編號」和訂購時填寫的「Email」查詢，
            <br />
            「訂單編號」在寄送給您的訂購確認信件中可查看。
          </p>
          <p className="brand-text-sm text-neutral">
            (有任何問題請使用
            <OfficialLINE />
            詢問 )
          </p>
        </section>

        <form noValidate>
          <fieldset>
            <div className="flex flex-col gap-2">
              <h3 className="brand-heading-sm mt-4 text-primary">輸入資料</h3>

              <LabelInput
                label="訂購 Email"
                type="email"
                registerProps={register("email")}
                value={watch("email")}
                error={errors?.email}
              />
              <LabelInput
                label="訂單編號"
                type="number"
                registerProps={register("orderId")}
                value={watch("orderId")}
                error={errors?.orderId}
              />
              <button
                type="button"
                onClick={handleFormSubmit}
                disabled={isSubmitting}
                className="brand-btn-base btn btn-primary m-auto w-full disabled:bg-opacity-100 disabled:text-opacity-100"
              >
                {isSubmitting ? <SpinnerLoading /> : "查詢訂單"}
              </button>
              {orderResultError && (
                <ErrorMessage message={orderResultError} classes="text-center" />
              )}
            </div>
          </fieldset>
        </form>

        {order && (
          <section className="mt-8">
            <h3 className="brand-heading-sm mb-4 mt-4 text-primary">查詢結果</h3>
            <OrderDetails order={order} />
          </section>
        )}

        {isSubmitting && <OrderSkeleton />}
      </div>

      {/* Meta Tag */}
      <SEOMeta
        pageTitle="查詢訂單"
        description="查詢您的訂單狀態，請輸入訂單編號與訂購時的 Email。"
      />
    </main>
  );
};

const OrderSkeleton = () => (
  <div className="mt-4 flex w-full animate-pulse rounded-md bg-base-300">
    <div className="flex w-full max-w-md flex-col gap-8 p-8">
      <div className="h-6 w-16 rounded-md bg-base-300" />
      {Array.from({ length: 4 }).map(() => (
        <div className="space-y-2 *:rounded-md *:bg-base-300">
          <div className="h-4 w-16" />
          <div className="h-4 w-32" />
        </div>
      ))}
    </div>
  </div>
);

export default OrderPage;
